(function () {
  'use strict';

  if (window.__globalSearchDrawerInit) return;
  window.__globalSearchDrawerInit = true;

  var DRAWER_KEY = 'drawer-search';
  var MIN_CHARS = 2;
  var DEBOUNCE_MS = 150;

  var els = {};
  var config = { limit: 10, token: '', apiVersion: '2024-10', searchUrl: '/search', moneyFormat: '', strings: {} };
  var LIMIT = 10;

  var openerEl = null;
  var hideTimer = null;

  var activeTab = 'products';
  var lastQuery = '';
  var abortController = null;
  var cache = new Map();

  /* ------------------------------------------------------------------ */
  /* Helpers                                                            */
  /* ------------------------------------------------------------------ */

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (s) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' }[s];
    });
  }

  function safeUrl(url) {
    var value = String(url || '');
    if (/^https?:\/\//i.test(value) || /^\//.test(value)) return value;
    return '#';
  }

  function normalize(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(new RegExp('[\\u0300-\\u036f]', 'g'), '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function thumbUrl(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + (width || 128);
  }

  function formatMoney(amount) {
    if (amount == null || amount === '' || isNaN(amount)) return '';
    var number = parseFloat(amount);
    var pattern = String(config.moneyFormat || '€{{amount_with_comma_separator}}').replace(/<[^>]*>/g, '');
    function delimit(n, decimals, thousands, decimal) {
      var fixed = n.toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
      return parts.join(decimal);
    }
    var formatted;
    if (pattern.indexOf('amount_no_decimals_with_comma_separator') !== -1) formatted = delimit(number, 0, '.', ',');
    else if (pattern.indexOf('amount_no_decimals_with_space_separator') !== -1) formatted = delimit(number, 0, ' ', ',');
    else if (pattern.indexOf('amount_with_comma_separator') !== -1) formatted = delimit(number, 2, '.', ',');
    else if (pattern.indexOf('amount_with_apostrophe_separator') !== -1) formatted = delimit(number, 2, "'", '.');
    else if (pattern.indexOf('amount_with_space_separator') !== -1) formatted = delimit(number, 2, ' ', ',');
    else if (pattern.indexOf('amount_no_decimals') !== -1) formatted = delimit(number, 0, ',', '.');
    else formatted = delimit(number, 2, ',', '.');
    return pattern.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, formatted);
  }

  function cleanTitle(title) {
    return String(title || '')
      .replace(/\(\s*women'?s\s*\)/gi, '')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  /* Drop a leading vendor/brand from the title so it isn't shown twice (the vendor
     is rendered separately). Case-insensitive prefix match; strips the vendor plus any
     following separator/whitespace. Leaves the title intact if it doesn't start with the
     vendor, or if stripping would empty it (e.g. a product literally named "ASICS"). */
  function stripVendor(title, vendor) {
    if (!vendor) return title;
    var t = String(title);
    var v = String(vendor);
    if (t.toLowerCase().indexOf(v.toLowerCase()) === 0) {
      var rest = t.slice(v.length).replace(/^[\s\-–—:]+/, '');
      return rest.length ? rest : t;
    }
    return t;
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, ms);
    };
  }

  /* ------------------------------------------------------------------ */
  /* Drawer open/close — mirrors the theme's drawer contract so the     */
  /* global scroll-lock listeners in theme.js keep working.             */
  /* ------------------------------------------------------------------ */

  function toggles() {
    return document.querySelectorAll('[data-drawer-toggle="' + DRAWER_KEY + '"]');
  }

  function setExpanded(value) {
    toggles().forEach(function (btn) { btn.setAttribute('aria-expanded', value ? 'true' : 'false'); });
  }

  function isOpen() {
    return !!els.drawer && els.drawer.classList.contains('drawer--visible');
  }

  function focusFirst() {
    var el = els.drawer.querySelector('[data-first-focus]') || els.content;
    if (el) el.focus({ preventScroll: true });
  }

  function openDrawer() {
    if (!els.drawer || isOpen()) return;
    clearTimeout(hideTimer);
    openerEl = document.activeElement;
    els.drawer.classList.remove('display-none');
    setTimeout(function () {
      setExpanded(true);
      els.drawer.classList.add('drawer--visible');
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: els.scrolls }));
      /* fallback timer: transitionend never fires when transitions are disabled */
      var focusTimer = setTimeout(focusFirst, 600);
      var onTransitionDone = function () {
        clearTimeout(focusTimer);
        focusFirst();
      };
      els.content.addEventListener('transitionend', onTransitionDone, { once: true });
      els.content.addEventListener('transitioncancel', onTransitionDone, { once: true });
    }, 1);
  }

  function closeDrawer() {
    if (!isOpen()) return;
    clearTimeout(hideTimer);
    setExpanded(false);
    els.drawer.classList.remove('drawer--visible');
    if (els.scrolls) els.scrolls.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    if (openerEl && document.contains(openerEl)) openerEl.focus({ preventScroll: true });
    openerEl = null;
    hideTimer = setTimeout(function () {
      if (!isOpen()) els.drawer.classList.add('display-none');
    }, 800);
  }

  /* ------------------------------------------------------------------ */
  /* Search state                                                       */
  /* ------------------------------------------------------------------ */

  function setLoading(value) {
    if (els.loadbar) els.loadbar.style.display = value ? 'block' : 'none';
  }

  function setStatus(text) {
    if (els.status) els.status.textContent = text || '';
  }

  function showSuggested() {
    if (els.suggested) els.suggested.hidden = false;
    els.panels.products.hidden = true;
    els.panels.collections.hidden = true;
    els.panels.products.innerHTML = '';
    els.panels.collections.innerHTML = '';
    setStatus('');
  }

  function showActivePanel() {
    if (els.suggested) els.suggested.hidden = true;
    els.panels.products.hidden = activeTab !== 'products';
    els.panels.collections.hidden = activeTab !== 'collections';
  }

  /* ------------------------------------------------------------------ */
  /* Fetching                                                           */
  /* ------------------------------------------------------------------ */

  /* Optimal-string-alignment edit distance (counts adjacent transpositions
     like "ncy"→"nyc" as one edit). Bails early on hopeless length gaps. */
  function editDistance(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 3;
    var prevPrev = null;
    var prev = [];
    var j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (var i = 1; i <= a.length; i++) {
      var curr = [i];
      for (j = 1; j <= b.length; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(prev[j] + 1, curr[j - 1] + 1, prev[j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
          v = Math.min(v, prevPrev[j - 2] + 1);
        }
        curr[j] = v;
      }
      prevPrev = prev;
      prev = curr;
    }
    return prev[b.length];
  }

  function tokenSimilarity(queryWord, titleWord) {
    if (queryWord === titleWord) return 1;
    if (queryWord.length >= 3 && (titleWord.indexOf(queryWord) === 0 || queryWord.indexOf(titleWord) === 0)) return 0.85;
    if (queryWord.length >= 3) {
      var allowed = queryWord.length >= 6 ? 2 : 1;
      var dist = editDistance(queryWord, titleWord);
      if (dist <= allowed) return 0.85 - dist * 0.05;
      if (titleWord.indexOf(queryWord) !== -1) return 0.5;
    }
    return 0;
  }

  /* Relevance = average best fuzzy match per query word, so a title that
     accounts for every (possibly misspelled) word beats one that matches
     only the generic words. Availability stays the primary sort key. */
  function scoreProducts(products, rawQuery) {
    var queryNorm = normalize(rawQuery);
    var words = queryNorm.split(' ').filter(Boolean);
    products.forEach(function (p) {
      var titleNorm = normalize(p.title);
      var skuNorm = normalize(p.sku);
      var score = 0;
      if (titleNorm === queryNorm || (skuNorm && skuNorm === queryNorm)) {
        score = 3;
      } else if (skuNorm && queryNorm.length >= 4 && skuNorm.indexOf(queryNorm) === 0) {
        score = 2;
      } else if (words.length) {
        /* Match against title AND vendor tokens: p.title is stored vendor-stripped
           (stripVendor), so a brand word in the query (e.g. "asics") would otherwise
           score 0 and drag the average down. */
        var titleWords = (titleNorm + ' ' + normalize(p.vendor)).split(' ').filter(Boolean);
        var total = 0;
        words.forEach(function (qw) {
          var best = 0;
          titleWords.forEach(function (tw) {
            var s = tokenSimilarity(qw, tw);
            if (s > best) best = s;
          });
          total += best;
        });
        score = total / words.length;
        if (titleNorm.indexOf(queryNorm) === 0) score += 0.5;
      }
      p._score = score;
    });
    return products.slice().sort(function (a, b) {
      var availA = a.available === true ? 1 : 0;
      var availB = b.available === true ? 1 : 0;
      if (availB !== availA) return availB - availA;
      if (b._score !== a._score) return b._score - a._score;
      return a.title.localeCompare(b.title);
    });
  }

  function mapSuggestProduct(p) {
    var image = (p.featured_image && p.featured_image.url) || p.image || '';
    var min = p.price_min != null ? parseFloat(p.price_min) / 100 : (p.price != null ? parseFloat(p.price) / 100 : null);
    var max = p.price_max != null ? parseFloat(p.price_max) / 100 : null;
    var cmp = p.compare_at_price_min != null ? parseFloat(p.compare_at_price_min) / 100 : null;
    var _vendor = String(p.vendor || '');
    /* suggest.json returns variants[].sku when 'variants.sku' is in the requested
       fields. Use the first variant's SKU for the row's SKU line + SKU scoring. */
    var _variants = (p.variants && p.variants.length) ? p.variants : [];
    var _sku = '';
    for (var vi = 0; vi < _variants.length; vi++) {
      if (_variants[vi] && _variants[vi].sku) { _sku = _variants[vi].sku; break; }
    }
    return {
      title: stripVendor(cleanTitle(p.title), _vendor),
      vendor: _vendor,
      sku: _sku,
      url: p.url || (p.handle ? '/products/' + p.handle : '#'),
      image: image,
      available: typeof p.available === 'boolean' ? p.available : null,
      price: min,
      priceVaries: min != null && max != null && max > min,
      compareAtPrice: cmp != null && min != null && cmp > min ? cmp : null
    };
  }

  function mapSuggestCollection(c) {
    return {
      title: c.title || '',
      url: c.url || (c.handle ? '/collections/' + c.handle : '#'),
      image: (c.featured_image && c.featured_image.url) || c.image || ''
    };
  }

  async function fetchJson(url, signal) {
    var res = await fetch(url, { headers: { Accept: 'application/json' }, signal: signal });
    var data = await res.json();
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return data;
  }

  async function fetchCollections(rawQuery, signal) {
    var params = new URLSearchParams({
      q: rawQuery,
      'resources[type]': 'collection',
      'resources[limit]': String(Math.min(LIMIT, 10))
    });
    try {
      var data = await fetchJson('/search/suggest.json?' + params.toString(), signal);
      return ((data.resources && data.resources.results && data.resources.results.collections) || [])
        .map(mapSuggestCollection)
        .slice(0, LIMIT);
    } catch (error) {
      if (error.name === 'AbortError') throw error;
      return []; /* collections are non-critical — degrade to empty */
    }
  }

  /* PRIMARY product source — the Online Store predictive search API reads the
     COMPLETE Online-Store-published catalog (unlike the custom-app Storefront
     token, whose sales channel is missing recently-published products). It caps
     results at 10 per type, which covers the drawer (LIMIT 10) and is the most
     the results page can get from this endpoint in one call. */
  async function fetchProductsSuggest(rawQuery, signal, max) {
    max = max || LIMIT;
    var params = new URLSearchParams({
      q: rawQuery,
      'resources[type]': 'product',
      'resources[limit]': '10',
      'resources[options][fields]': 'title,product_type,variants.title,variants.sku,vendor',
      'resources[options][unavailable_products]': 'show'
    });
    var data = await fetchJson('/search/suggest.json?' + params.toString(), signal);
    var products = ((data.resources && data.resources.results && data.resources.results.products) || [])
      .map(mapSuggestProduct);
    return scoreProducts(products, rawQuery).slice(0, max);
  }

  async function runProductSearch(term, first, signal) {
    var gql = 'query GlobalSearch($term: String!, $first: Int!) {' +
      ' search(query: $term, types: [PRODUCT], first: $first, unavailableProducts: LAST) {' +
      ' edges { node { ... on Product { title handle vendor onlineStoreUrl availableForSale' +
      ' priceRange { minVariantPrice { amount } maxVariantPrice { amount } }' +
      ' compareAtPriceRange { minVariantPrice { amount } maxVariantPrice { amount } }' +
      ' variants(first: 30) { edges { node { sku availableForSale price { amount } compareAtPrice { amount } } } }' +
      ' images(first: 1) { edges { node { url } } } } } } } }';

    var res = await fetch('/api/' + config.apiVersion + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': config.token,
        Accept: 'application/json'
      },
      body: JSON.stringify({ query: gql, variables: { term: term, first: first } }),
      signal: signal
    });
    var data = await res.json();
    if (!res.ok || (data.errors && data.errors.length)) throw new Error('GraphQL search failed');

    var edges = (data && data.data && data.data.search && data.data.search.edges) || [];
    return edges
      .map(function (e) { return e && e.node; })
      .filter(function (n) { return n && (n.onlineStoreUrl || n.handle); })
      .map(function (n) {
        var imgEdges = (n.images && n.images.edges) || [];
        var variantEdges = (n.variants && n.variants.edges) || [];
        var firstVariantSku = variantEdges[0] && variantEdges[0].node && variantEdges[0].node.sku;

        /* Walk variants to find the lowest IN-STOCK price (mirrors the
           theme's product-grid-item "true_lowest_price" fix). Variants
           priced 0 are draft/placeholder and ignored. */
        var inStockPrices = [];
        var inStockCompares = [];
        var anyVariantPrices = [];
        variantEdges.forEach(function (e) {
          var v = e && e.node;
          if (!v || !v.price) return;
          var p = parseFloat(v.price.amount);
          if (isNaN(p) || p <= 0) return;
          anyVariantPrices.push(p);
          if (v.availableForSale) {
            inStockPrices.push(p);
            var cmp = v.compareAtPrice && parseFloat(v.compareAtPrice.amount);
            inStockCompares.push(!isNaN(cmp) && cmp > p ? cmp : null);
          }
        });

        var displayPrice = null;
        var priceVaries = false;
        var compareAtPrice = null;
        if (inStockPrices.length) {
          var minInStock = Math.min.apply(null, inStockPrices);
          var maxInStock = Math.max.apply(null, inStockPrices);
          displayPrice = minInStock;
          priceVaries = maxInStock > minInStock;
          /* Compare-at on the matching min-priced in-stock variant only. */
          for (var i = 0; i < inStockPrices.length; i++) {
            if (inStockPrices[i] === minInStock && inStockCompares[i]) {
              compareAtPrice = inStockCompares[i];
              break;
            }
          }
        } else if (anyVariantPrices.length) {
          displayPrice = Math.min.apply(null, anyVariantPrices);
        } else {
          /* Fall back to priceRange when variant detail is unavailable. */
          var rangeMin = n.priceRange && n.priceRange.minVariantPrice && parseFloat(n.priceRange.minVariantPrice.amount);
          var rangeMax = n.priceRange && n.priceRange.maxVariantPrice && parseFloat(n.priceRange.maxVariantPrice.amount);
          if (!isNaN(rangeMin) && rangeMin > 0) displayPrice = rangeMin;
          else if (!isNaN(rangeMax) && rangeMax > 0) displayPrice = rangeMax;
          if (!isNaN(rangeMin) && !isNaN(rangeMax) && rangeMin > 0 && rangeMax > rangeMin) priceVaries = true;
        }

        var _vendor = String(n.vendor || '');
        return {
          title: stripVendor(cleanTitle(n.title), _vendor),
          vendor: _vendor,
          sku: firstVariantSku || '',
          url: n.onlineStoreUrl || '/products/' + n.handle,
          image: (imgEdges[0] && imgEdges[0].node && imgEdges[0].node.url) || '',
          available: n.availableForSale === true,
          price: displayPrice,
          priceVaries: priceVaries,
          compareAtPrice: compareAtPrice
        };
      });
  }

  /* Adjacent-swap and single-deletion variants of each word — one retry
     query catches the common one-letter typos ("ncy"→"nyc", "osyter"→
     "oyster", "dunkk"→"dunk"). */
  function fuzzyVariants(rawQuery) {
    var variants = [];
    var seen = {};
    var words = normalize(rawQuery).split(' ').filter(Boolean);
    words.forEach(function (word) { seen[word] = 1; });
    function add(v) {
      if (v.length >= 3 && !seen[v] && variants.length < 24) {
        seen[v] = 1;
        variants.push(v);
      }
    }
    words.forEach(function (word) {
      var i;
      if (word.length >= 3) {
        for (i = 0; i < word.length - 1; i++) {
          add(word.slice(0, i) + word[i + 1] + word[i] + word.slice(i + 2));
        }
      }
      if (word.length >= 4) {
        for (i = 0; i < word.length; i++) {
          add(word.slice(0, i) + word.slice(i + 1));
        }
      }
    });
    return variants;
  }

  /* Primary product source — Storefront API search with the wildcard term
     expansion ported from the Sneaker Encyclopedia module. LAST puts every
     available product before any sold-out one, and each result carries its
     SKU and image in the same response. */
  async function fetchProductsGraphql(rawQuery, signal, max) {
    max = max || LIMIT;
    /* Sanitize the query for Shopify search syntax. Critically, turn hyphens into
       spaces: a '-' before a word is the Storefront EXCLUDE operator, so an
       un-sanitized "Gel-Cumulus" was parsed as "Gel AND NOT Cumulus" and actively
       hid the product. Also strip the other operator/wildcard chars. */
    var q = String(rawQuery || '')
      .trim()
      .replace(/[\\"()+~:*]/g, ' ')
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    if (!q) return [];
    var words = q.split(' ').filter(Boolean);
    var q2 = words.join('');

    /* Per-word wildcards instead of one multi-word wildcard. A single
       title:*gel cumulus 16* breaks on the embedded spaces, and title:*gelcumulus16*
       never matches a title that indexes as separate tokens (gel, cumulus, 16).
       titleAll = precision (every query word must be in the title);
       anyWord = recall (any word in title/vendor/handle, re-ranked by scoreProducts). */
    var titleAll = '(' + words.map(function (w) { return 'title:*' + w + '*'; }).join(' AND ') + ')';
    var anyWord = words.map(function (w) {
      return 'title:*' + w + '* OR vendor:*' + w + '* OR handle:*' + w + '*';
    }).join(' OR ');

    /* SKU lookups keep the raw query - a hyphen inside a SKU is a literal char. */
    var rawSku = String(rawQuery || '').trim().replace(/[\\"()*]/g, ' ').replace(/\s+/g, ' ').trim();
    var rawSku2 = rawSku.replace(/\s+/g, '');
    var skuClause = 'variants.sku:*' + rawSku + '*';
    if (rawSku2 !== rawSku && rawSku2.length > 2) skuClause += ' OR variants.sku:*' + rawSku2 + '*';

    var concat = q2.length > 2 ? ' OR title:*' + q2 + '* OR handle:*' + q2 + '*' : '';

    var term = '(' + q + ') OR ' + titleAll + ' OR ' + anyWord + ' OR ' + skuClause + concat;
    var first = Math.min(Math.max(max * 2, 50), 100);

    var products = await runProductSearch(term, first, signal);
    var ranked = scoreProducts(products, rawQuery);

    /* Weak best match → likely typos the engine didn't correct. Retry once
       with swap/deletion variants and merge, so the intended product enters
       the candidate set and the fuzzy scorer can lift it to the top. */
    var best = 0;
    ranked.forEach(function (p) { if (p._score > best) best = p._score; });
    if (!ranked.length || best < 0.75) {
      var variants = fuzzyVariants(q);
      if (variants.length) {
        var fuzzyTerm = variants.map(function (v) {
          return 'title:*' + v + '* OR handle:*' + v + '*';
        }).join(' OR ');
        try {
          var extra = await runProductSearch(fuzzyTerm, first, signal);
          var seenUrls = {};
          products.forEach(function (p) { seenUrls[p.url] = 1; });
          extra.forEach(function (p) { if (!seenUrls[p.url]) products.push(p); });
          ranked = scoreProducts(products, rawQuery);
        } catch (error) {
          if (error.name === 'AbortError') throw error;
          /* keep primary results */
        }
      }
    }

    return ranked.slice(0, max);
  }

  async function fetchResults(rawQuery, signal) {
    var collectionsPromise = fetchCollections(rawQuery, signal);
    /* Primary: Storefront API relevance search — per-word wildcards, hyphen-safe
       term builder, fuzzy retry, richer variant data, and NOT capped at 10. All
       Online-Store products are now published to the token's channel (Kyaro
       Headless), so it covers the full catalog. suggest.json (Online Store
       predictive search) remains as a fallback if the token call fails. */
    var products = null;
    if (config.token) {
      try {
        products = await fetchProductsGraphql(rawQuery, signal);
      } catch (error) {
        if (error.name === 'AbortError') throw error;
        products = null;
      }
    }
    if (products === null) products = await fetchProductsSuggest(rawQuery, signal);
    return { products: products, collections: await collectionsPromise };
  }

  /* ------------------------------------------------------------------ */
  /* Rendering                                                          */
  /* ------------------------------------------------------------------ */

  function renderEmpty(query) {
    var message = (config.strings.noResults || 'No results for "[terms]"').replace('[terms]', escapeHtml(query));
    return '<p class="global-search__message">' + message + '</p>';
  }

  function renderError() {
    return '<p class="global-search__message global-search__message--error">' +
      escapeHtml(config.strings.error || 'Something went wrong. Please try again.') + '</p>';
  }

  function renderThumb(image, title) {
    if (image) {
      return '<img class="global-search__item__image" src="' + escapeHtml(safeUrl(thumbUrl(image))) + '" alt="' + escapeHtml(title) + '" width="64" height="64" loading="lazy">';
    }
    return '<span class="global-search__item__image global-search__item__image--placeholder" aria-hidden="true">' + escapeHtml((title || '?').charAt(0)) + '</span>';
  }

  function renderProductRow(p) {
    /* Sold-out only — the green in-stock badge is removed for grey-theme parity */
    var stockBadge = '';
    if (p.available === false) {
      stockBadge = '<span class="global-search__badge global-search__badge--out">' + escapeHtml(config.strings.outOfStock || 'Sold out') + '</span>';
    }

    var onSale = p.compareAtPrice != null;
    var saleBadge = onSale
      ? '<span class="global-search__badge global-search__badge--sale">' +
        '-' + Math.round((p.compareAtPrice - p.price) / p.compareAtPrice * 100) + '%' +
        '</span>'
      : '';

    var priceHtml = '';
    if (p.price != null) {
      var fromPrefix = p.priceVaries ? '<span class="global-search__item__from">' + escapeHtml(config.strings.from || 'Vanaf') + '</span> ' : '';
      var compareHtml = onSale
        ? '<span class="global-search__item__compare">' + escapeHtml(formatMoney(p.compareAtPrice)) + '</span>'
        : '';
      priceHtml = '<span class="global-search__item__price' + (onSale ? ' on-sale' : '') + '">' +
        fromPrefix + escapeHtml(formatMoney(p.price)) +
        compareHtml +
        '</span>';
    }

    var vendorHtml = p.vendor ? '<span class="global-search__item__vendor">' + escapeHtml(p.vendor) + '</span>' : '';
    var sku = p.sku ? '<span class="global-search__item__sku">' + escapeHtml(p.sku) + '</span>' : '';

    return '<a class="global-search__item" href="' + escapeHtml(safeUrl(p.url)) + '">' +
      '<span class="global-search__item__thumb">' +
      renderThumb(p.image, (p.vendor ? p.vendor + ' ' : '') + p.title) +
      (saleBadge ? '<span class="global-search__item__badges">' + saleBadge + '</span>' : '') +
      '</span>' +
      '<span class="global-search__item__info">' +
      vendorHtml +
      '<span class="global-search__item__title">' + escapeHtml(p.title) + '</span>' +
      sku +
      priceHtml +
      (stockBadge ? '<span class="global-search__item__stock">' + stockBadge + '</span>' : '') +
      '</span></a>';
  }

  function renderCollectionRow(c) {
    return '<a class="global-search__item" href="' + escapeHtml(safeUrl(c.url)) + '">' +
      '<span class="global-search__item__thumb">' + renderThumb(c.image, c.title) + '</span>' +
      '<span class="global-search__item__info">' +
      '<span class="global-search__item__title">' + escapeHtml(c.title) + '</span>' +
      '</span></a>';
  }

  function renderResults(results, query) {
    if (results.products.length) {
      var seeAllUrl = (config.seeAllBase || config.searchUrl) + '?q=' + encodeURIComponent(query);
      els.panels.products.innerHTML =
        '<div class="global-search__list">' + results.products.map(renderProductRow).join('') + '</div>' +
        '<div class="global-search__footer">' +
        '<a class="btn btn--outline btn--full global-search__see-all" href="' + escapeHtml(seeAllUrl) + '">' +
        escapeHtml(config.strings.seeAll || 'See all') + ' &rarr;</a></div>';
    } else {
      els.panels.products.innerHTML = renderEmpty(query);
    }

    els.panels.collections.innerHTML = results.collections.length
      ? '<div class="global-search__list">' + results.collections.map(renderCollectionRow).join('') + '</div>'
      : renderEmpty(query);

    var count = activeTab === 'products' ? results.products.length : results.collections.length;
    setStatus(count
      ? (config.strings.resultsCount || '[count] results').replace('[count]', count).replace(/\s+/g, ' ').trim()
      : (config.strings.noResults || 'No results for "[terms]"').replace('[terms]', query));
    showActivePanel();
  }

  /* ------------------------------------------------------------------ */
  /* Query flow                                                         */
  /* ------------------------------------------------------------------ */

  async function runSearch(rawQuery) {
    var query = (rawQuery || '').trim();

    if (query.length < MIN_CHARS) {
      lastQuery = '';
      if (abortController) abortController.abort();
      setLoading(false);
      showSuggested();
      return;
    }

    if (query === lastQuery) return;
    lastQuery = query;

    if (cache.has(query)) {
      setLoading(false);
      renderResults(cache.get(query), query);
      return;
    }

    if (abortController) abortController.abort();
    abortController = new AbortController();
    var signal = abortController.signal;

    setLoading(true);
    showActivePanel();

    try {
      var results = await fetchResults(query, signal);

      cache.set(query, results);
      if (query !== lastQuery) return;
      setLoading(false);
      renderResults(results, query);
    } catch (error) {
      if (error.name === 'AbortError') return;
      if (query !== lastQuery) return;
      setLoading(false);
      els.panels.products.innerHTML = renderError();
      els.panels.collections.innerHTML = renderError();
      setStatus(config.strings.error || 'Something went wrong. Please try again.');
      showActivePanel();
    }
  }

  var debouncedSearch = debounce(function () { runSearch(els.input.value); }, DEBOUNCE_MS);

  /* ------------------------------------------------------------------ */
  /* Tabs                                                               */
  /* ------------------------------------------------------------------ */

  function selectTab(name, focusButton) {
    activeTab = name;
    els.tabs.forEach(function (btn) {
      var selected = btn.dataset.searchTab === name;
      btn.setAttribute('aria-selected', selected ? 'true' : 'false');
      btn.setAttribute('tabindex', selected ? '0' : '-1');
      btn.classList.toggle('global-search__tab--active', selected);
      if (selected && focusButton) btn.focus();
    });
    if (lastQuery) {
      var cached = cache.get(lastQuery);
      if (cached) renderResults(cached, lastQuery);
      else showActivePanel();
    } else {
      showSuggested();
    }
  }

  /* ------------------------------------------------------------------ */
  /* Element binding (re-run on theme editor section re-render)         */
  /* ------------------------------------------------------------------ */

  function loadConfig() {
    var configEl = document.querySelector('[data-search-config]');
    if (configEl) {
      try {
        var parsed = JSON.parse(configEl.textContent);
        for (var key in parsed) config[key] = parsed[key];
      } catch (e) { /* fall back to defaults */ }
    }
    LIMIT = Math.max(parseInt(config.limit, 10) || 10, 1);
  }

  function bindElements() {
    var drawer = document.querySelector('[data-drawer="' + DRAWER_KEY + '"]');
    if (!drawer || drawer === els.drawer) return false;

    els.drawer = drawer;
    els.content = drawer.querySelector('.drawer__content');
    els.scrolls = drawer.querySelector('[data-drawer-scrolls]');
    els.underlay = drawer.querySelector('[data-drawer-underlay]');
    els.input = drawer.querySelector('[data-search-input]');
    els.loadbar = drawer.querySelector('[data-search-loading]');
    els.suggested = drawer.querySelector('[data-search-suggested]');
    els.status = drawer.querySelector('[data-search-status]');
    els.tabs = Array.prototype.slice.call(drawer.querySelectorAll('[data-search-tab]'));
    els.panels = {
      products: drawer.querySelector('[data-search-panel="products"]'),
      collections: drawer.querySelector('[data-search-panel="collections"]')
    };

    loadConfig();

    activeTab = 'products';
    lastQuery = '';
    cache.clear();

    els.input.addEventListener('input', debouncedSearch);

    if (els.underlay) els.underlay.addEventListener('click', closeDrawer);

    els.content.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || !isOpen()) return;
      var focusable = els.content.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      var visible = Array.prototype.filter.call(focusable, function (el) {
        return el.offsetParent !== null && !el.disabled;
      });
      if (!visible.length) return;
      var first = visible[0];
      var last = visible[visible.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    els.tabs.forEach(function (btn) {
      btn.addEventListener('click', function () { selectTab(btn.dataset.searchTab, false); });
      btn.addEventListener('keydown', function (event) {
        var index = els.tabs.indexOf(btn);
        var next = null;
        if (event.key === 'ArrowRight') next = (index + 1) % els.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + els.tabs.length) % els.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = els.tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        selectTab(els.tabs[next].dataset.searchTab, true);
      });
    });

    drawer.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-search-chip]');
      if (!chip) return;
      els.input.value = chip.textContent.trim();
      els.input.focus();
      runSearch(els.input.value);
    });

    return true;
  }

  /* ------------------------------------------------------------------ */
  /* Global listeners (bound once)                                      */
  /* ------------------------------------------------------------------ */

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-drawer-toggle="' + DRAWER_KEY + '"]');
    if (!toggle) return;
    event.preventDefault();
    /* Re-bind if the drawer reference was never set or has been detached from the
       DOM (section re-render on some navigations). Without this the toggle calls
       preventDefault and then silently no-ops because openDrawer bails on a stale
       els.drawer. The guard only fires when the reference is missing/detached, so a
       live drawer is never re-bound and no duplicate listeners are attached. */
    if (!els.drawer || !document.contains(els.drawer)) {
      els.drawer = null;
      bindElements();
    }
    if (isOpen()) { closeDrawer(); } else { openDrawer(); }
  });

  document.addEventListener('keyup', function (event) {
    if ((event.code === 'Escape' || event.key === 'Escape') && isOpen()) closeDrawer();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-drawer="' + DRAWER_KEY + '"]')) {
      els.drawer = null;
      bindElements();
    }
  });

  bindElements();

  /* ------------------------------------------------------------------ */
  /* Full results page (/search?q=) — same ranking as the drawer        */
  /* ------------------------------------------------------------------ */

  function renderGridCard(p) {
    var badges = '';
    if (p.compareAtPrice != null && p.price != null) {
      badges += '<span class="search-results-grid__badge search-results-grid__badge--sale">' +
        '-' + Math.round((p.compareAtPrice - p.price) / p.compareAtPrice * 100) + '%</span>';
    }
    if (p.available === false) {
      badges += '<span class="search-results-grid__badge search-results-grid__badge--out">' +
        escapeHtml(config.strings.outOfStock || 'Sold out') + '</span>';
    }
    var media = p.image
      ? '<img class="search-results-grid__image" src="' + escapeHtml(safeUrl(thumbUrl(p.image, 480))) + '" alt="" loading="lazy">'
      : '<span class="search-results-grid__media--placeholder" aria-hidden="true">' + escapeHtml((p.title || '?').charAt(0)) + '</span>';

    var priceHtml = '';
    if (p.price != null) {
      var onSale = p.compareAtPrice != null;
      var fromPrefix = p.priceVaries ? '<span class="search-results-grid__from">' + escapeHtml(config.strings.from || 'Vanaf') + '</span> ' : '';
      var compareHtml = onSale
        ? '<span class="search-results-grid__compare">' + escapeHtml(formatMoney(p.compareAtPrice)) + '</span>'
        : '';
      priceHtml = '<span class="search-results-grid__price' + (onSale ? ' on-sale' : '') + '">' +
        fromPrefix + escapeHtml(formatMoney(p.price)) + compareHtml +
        '</span>';
    }

    var vendorHtml = p.vendor
      ? '<span class="search-results-grid__vendor">' + escapeHtml(p.vendor) + '</span>'
      : '';

    return '<a class="search-results-grid__item" href="' + escapeHtml(safeUrl(p.url)) + '">' +
      '<span class="search-results-grid__media' + (p.image ? '' : ' search-results-grid__media--no-image') + '">' +
      media +
      (badges ? '<span class="search-results-grid__badges">' + badges + '</span>' : '') +
      '</span>' +
      '<span class="search-results-grid__info">' +
      vendorHtml +
      '<span class="search-results-grid__name">' + escapeHtml(p.title) + '</span>' +
      priceHtml +
      '</span>' +
      '</a>';
  }

  function initResultsGrid() {
    var wrap = document.querySelector('[data-search-results]');
    if (!wrap) return;
    var grid = wrap.querySelector('[data-search-results-grid]');
    var heading = wrap.querySelector('[data-search-results-heading]');
    var termEl = wrap.querySelector('[data-search-results-term]');
    var countEl = wrap.querySelector('[data-search-results-count]');
    var message = wrap.querySelector('[data-search-results-message]');

    var q = '';
    try {
      q = (new URLSearchParams(window.location.search).get('q') || '').trim();
    } catch (e) { /* no query — leave the page as-is */ }
    if (!q || q.length < MIN_CHARS) return;

    loadConfig();
    if (termEl) termEl.textContent = q;
    if (heading) heading.hidden = false;

    var max = parseInt(wrap.getAttribute('data-limit'), 10) || 60;
    /* Storefront API relevance search (up to `max`, not capped at 10), with a
       suggest.json fallback if the token call fails. */
    var run = config.token
      ? fetchProductsGraphql(q, undefined, max).catch(function (error) {
          if (error.name === 'AbortError') throw error;
          return fetchProductsSuggest(q, undefined, max);
        })
      : fetchProductsSuggest(q, undefined, max);

    run.then(function (products) {
      if (products.length) {
        grid.innerHTML = products.map(renderGridCard).join('');
        if (countEl) {
          var template = (config.strings.resultsCount || '[count] results').replace(/\s+/g, ' ').trim();
          countEl.textContent = template.replace('[count]', products.length);
          countEl.hidden = false;
        }
      } else if (message) {
        message.textContent = (config.strings.noResults || 'No results for "[terms]"').replace('[terms]', q);
        message.hidden = false;
      }
    }).catch(function () {
      if (message) {
        message.textContent = config.strings.error || 'Something went wrong. Please try again.';
        message.hidden = false;
      }
    });
  }

  initResultsGrid();
})();
